module.exports = __webpack_public_path__ + "fonts/icomoon.c0c6bf0.eot";